export const SITE_URL = 'https://alisterbryan.com';

export const SITE_CONFIG = {
    name: 'Alister Bryan',
    legalName: 'Alister Bryan',
    location: 'São Paulo, Brasil',
    email: 'alisterbryansantos@gmail.com',
    phoneDisplay: '+55 15 99164-2071',
    whatsappUrl: 'https://wa.me/5515991642071',
    instagramHandle: '@alister_audiovisual',
    instagramUrl: 'https://instagram.com/alister_audiovisual',
    logoPath: '/ab_logo.png',
    socialImagePath: '/ab_logo.jpg',
};

export const socialImageUrl = `${SITE_URL}${SITE_CONFIG.socialImagePath}`;
